import { createRouter } from '@tanstack/react-router';

import { logger } from '@/lib/logger';

import { NotFound } from './NotFound';
import { RouterErrorBoundary } from './components/RouterErrorBoundary';
import { routeTree } from './routes';

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultNotFoundComponent: NotFound,
  defaultErrorComponent: RouterErrorBoundary,
  defaultOnCatch: (error, info) => {
    logger.error(error, { ...info });
  },
});

router.subscribe('onBeforeLoad', () => {
  window.scrollTo(0, 0);
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }

  interface HistoryState {
    showVerificationError?: boolean;
  }
}
